'use strict';

//Conditional Wrapper Util
var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children,
    elseWrapper = _ref.elseWrapper;
  return condition ? wrapper(children) : elseWrapper(children);
};

exports.ConditionalWrapper = ConditionalWrapper;
